import { Component } from '@angular/core';

@Component({
    templateUrl: './trends-onsite-section.component.html',
    standalone: false
})
export class TrendsOnsiteSectionComponent {

  showFilters = true;

  constructor() {}

}
